import {createContext} from 'react'
import type {Dispatch, SetStateAction} from 'react'
import type {Country} from './types'

export type ConsentExperienceContextValue = {
  marketingTargetedCountries: Country[]
  selectedCountry: Country | null
  setSelectedCountry: Dispatch<SetStateAction<Country | null>>
}

export const ConsentExperienceContext = createContext<ConsentExperienceContextValue>({
  marketingTargetedCountries: [],
  selectedCountry: null,
  setSelectedCountry: () => {},
})

try{ ConsentExperienceContext.displayName ||= 'ConsentExperienceContext' } catch {}